// Constantes compartidas de los tipos de crédito (KPIs de payments).
// Los gradientes son los mismos que usan los chips de compra en CreditsSection,
// para que el carrusel de la Navbar coincida visualmente con la pantalla de compra.

export const CREDIT_KPI_CODES = [
  "prospection_credits",
  "validation_credits",
  "ai_message_credits",
];

export const CREDIT_CHIP_GRADIENTS = {
  prospection_credits: "linear-gradient(0deg, #359FBB 0%, #5AC9E7 100%)",
  validation_credits: "linear-gradient(0deg, #572173 0%, #8B1EC4 100%)",
  ai_message_credits:
    "linear-gradient(150deg, #359FBB 0%, rgba(255, 184, 243, 0.50) 100%)",
};

export const DEFAULT_CREDIT_CHIP_GRADIENT =
  CREDIT_CHIP_GRADIENTS.prospection_credits;

export const CREDIT_KPI_LABELS = {
  prospection_credits: "Créditos de prospección",
  validation_credits: "Créditos de validación",
  ai_message_credits: "Créditos de mensajes con IA",
};
